import {replace} from 'react-router-redux'
import {linkFinder} from '../core/links'
import {DEFAULT_TICKET_QUERY, loadTicketStream} from '../ticket/actions'
import TicketStream from '../ticket/components/TicketStream'
import {loadProvider as loadActradisProvider, resetProvider as resetActradisProvider} from '../actradis/actions'
import {loadActivityRef, loadOpeningTicketPurposeRef} from '../reference/actions'
import {DEFAULT_PROVIDER_QUERY, DEFAULT_PROVIDER_COVERAGE_QUERY, DEFAULT_CONTACT_QUERY, DEFAULT_CONTACT_STATS_QUERY, loadProviderStream, loadProviderCoverage, loadProvider, loadContactStream, loadContact} from './actions'
import ProviderLayout from './components/ProviderLayout'
import ProviderStreamLayout from './components/ProviderStreamLayout'
import ProviderCoverageLayout from './components/ProviderCoverageLayout'
import ProviderCoverageDashboardLayout from './components/ProviderCoverageDashboardLayout'
import ProviderDetail from './components/ProviderDetail'
import ProviderDashboard from './components/ProviderDashboard'
import ContactLayout from './components/ContactLayout'
import ContactStreamLayout from './components/ContactStreamLayout'
import ContactStream from './components/ContactStream'
import ContactDetail from './components/ContactDetail'
import ContactDashboard from './components/ContactDashboard'
import ProviderCommitmentLayout from './components/ProviderCommitmentLayout'
import ContactCommitmentLayout from './components/ContactCommitmentLayout'

function enterProvider(getState) {
    return (dispatch, params) => {
        const state = getState()
        const _appLinks = state.app._links

        return dispatch(loadProvider(params.id)).then((action) => {
            return Promise.all([
                // dashboard
                _appLinks.find(linkFinder('actradis/providercompanies')) && dispatch(loadActradisProvider(action.provider.siretNumber))
            ])
        })
    }
}

export function providerContactRoute(rootPath, dispatcher, {getState}) {

    function enterContactStream(dispatch, params) {
        const state = getState()
        const {criteria} = state.provider.contact

        return dispatch(loadContactStream({...DEFAULT_CONTACT_QUERY, ...criteria}))
    }

    function enterContact(dispatch, params) {
        const state = getState()
        const {contactFilter} = state.provider.contact
        const _appLinks = state.app._links

        return dispatch(loadContact(params.id, {...DEFAULT_CONTACT_STATS_QUERY, ...contactFilter})).then((action) => {
            return Promise.all([
                // dashboard
                _appLinks.find(linkFinder('tickets')) && dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, ...contactFilter, activeProviders: params.id, range: {offset: 0, limit: 0}})),
                _appLinks.find(linkFinder('actradis/providercompanies')) && (action.contact.providerCompany && dispatch(loadActradisProvider(action.contact.providerCompany.siretNumber)) || dispatch(resetActradisProvider()))
            ])
        })
    }

    function enterTicketStream(dispatch, params) {
        const state = getState()
        const {contactFilter} = state.provider

        return dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, ...contactFilter, activeProviders: params.id}))
    }

    function entreCommitment(dispatch) {
        const state = getState()
        const {contact} = state.provider.contact

        return Promise.all([
            dispatch(loadActivityRef()),
            dispatch(loadOpeningTicketPurposeRef(contact.company))
        ])
    }

    return {
        path: rootPath,
        component: ContactLayout,
        onEnter: dispatcher(enterContactStream),
        indexRoute: {
            component: ContactStreamLayout
        },
        childRoutes: [{
            path: ':id',
            component: ContactDetail,
            onEnter: dispatcher(enterContact),
            indexRoute: {
                component: ContactDashboard
            },
            childRoutes: [{
                path: 'tickets',
                component: TicketStream,
                onEnter: dispatcher(enterTicketStream)
            }, {
                path: 'commitments',
                component: ContactCommitmentLayout,
                onEnter: dispatcher(entreCommitment)
            }]
        }]
    }
}

export function providerDirectoryRoute(rootPath, dispatcher, {getState}) {

    function enterProviderStream(dispatch, params) {
        const state = getState()
        const {criteria} = state.provider

        return Promise.all([
            dispatch(loadProviderStream({...DEFAULT_PROVIDER_QUERY, ...criteria, filtered: false})),
            dispatch(loadActivityRef())
        ])
    }

    return {
        path: rootPath,
        component: ProviderLayout,
        onEnter: dispatcher(enterProviderStream),
        indexRoute: {
            component: ProviderStreamLayout
        },
        childRoutes: [{
            path: ':id',
            component: ProviderDetail,
            onEnter: dispatcher(enterProvider(getState)),
            indexRoute: {
                component: ProviderDashboard
            },
            childRoutes: [{
                path: 'providercontacts',
                component: ContactStream,
                onEnter: dispatcher((d, p) => d(loadContactStream({...DEFAULT_CONTACT_QUERY, providerCompanyUid: p.id})))
            }, {
                path: 'activities',
                component: ProviderCommitmentLayout,
                onEnter: dispatcher((d, p) => d(loadActivityRef()))
            }]
        }]
    }
}

export function providerCoverageRoute(rootPath, dispatcher, {getState}) {

    function enterProviderCoverage(dispatch, params) {
        const state = getState()
        const {criteria} = state.provider.coverage

        return Promise.all([
            dispatch(loadProviderCoverage({...DEFAULT_PROVIDER_COVERAGE_QUERY, ...criteria})),
            dispatch(loadActivityRef())
        ])
    }

    return {
        path: rootPath,
        component: ProviderCoverageLayout,
        onEnter: dispatcher(enterProviderCoverage),
        indexRoute: {
            component: ProviderCoverageDashboardLayout
        }
    }
}

export default function(rootPath, dispatcher, {getState}) {

    function enterProviderStream(dispatch, params) {
        const state = getState()
        const {criteria} = state.provider

        return Promise.all([
            dispatch(loadProviderStream({...DEFAULT_PROVIDER_QUERY, ...criteria, filtered: true})),
            dispatch(loadActivityRef())
        ])
    }

    return {
        path: rootPath,
        component: ProviderLayout,
        onEnter: dispatcher(enterProviderStream),
        indexRoute: {
            component: ProviderStreamLayout
        },
        childRoutes: [{
            path: ':id',
            component: ProviderDetail,
            onEnter: dispatcher(enterProvider(getState)),
            indexRoute: {
                component: ProviderDashboard
            },
            childRoutes: [{
                path: 'providercontacts',
                component: ContactStream,
                onEnter: dispatcher((d, p) => d(loadContactStream({...DEFAULT_CONTACT_QUERY, providerCompanyUid: p.id})))
            }, {
                path: 'activities',
                component: ProviderCommitmentLayout,
                onEnter: dispatcher((d, p) => d(loadActivityRef()))
            }]
        }]
    }
}


// WEBPACK FOOTER //
// ./lib/provider/routes.js